import { useTranslation } from 'react-i18next';
import { Checkbox, SingleDatePicker, Widget } from '@asset-metrix/portal-ui';
import { Stack } from '@mantine/core';

import { LimitSetupDraft } from './createInvestmentLimitModel';

import styles from './createInvestmentLimitModal.module.scss';

export type WorkflowStepProps = {
  draft: LimitSetupDraft;
  onDraftChange: (update: Partial<LimitSetupDraft>) => void;
};

function startOfToday() {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

export function WorkflowStep({ draft, onDraftChange }: WorkflowStepProps) {
  const { t } = useTranslation();
  const today = startOfToday();

  return (
    <Stack className={styles['modal-step']}>
      <Widget title={t('app.investmentLimit.widgets.workflow')}>
        <div className={styles['modal-card-content']}>
          <Checkbox
            checked={draft.breachWorkflowApproval}
            label={t('app.investmentLimit.fields.breachApproval')}
            onChange={(checked) =>
              onDraftChange({ breachWorkflowApproval: checked })
            }
          />
        </div>
      </Widget>
      <Widget title={t('app.investmentLimit.widgets.validity')}>
        <div className={styles['modal-card-content']}>
          <div className={styles['form-grid']}>
            <SingleDatePicker
              label={t('app.investmentLimit.fields.validFrom')}
              minDate={today}
              maxDate={
                draft.validIndefinitely || draft.validTo == null
                  ? undefined
                  : draft.validTo
              }
              onChange={(value) => onDraftChange({ validFrom: value })}
              placeholder={t('app.investmentLimit.fields.selectStartDate')}
              value={draft.validFrom}
            />
            <SingleDatePicker
              disabled={draft.validIndefinitely}
              label={t('app.investmentLimit.fields.validTo')}
              minDate={draft.validFrom ?? undefined}
              onChange={(value) => onDraftChange({ validTo: value })}
              placeholder={t('app.investmentLimit.fields.selectEndDate')}
              value={draft.validTo}
            />
          </div>
          <Checkbox
            checked={draft.validIndefinitely}
            label={t('app.investmentLimit.fields.validIndefinitely')}
            onChange={(checked) =>
              onDraftChange({
                validIndefinitely: checked,
                validTo: checked ? null : draft.validTo,
              })
            }
          />
        </div>
      </Widget>
    </Stack>
  );
}
